<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:pt="item.pt" :heightLeft="item.heightLeft" :heightRight="item.heightRight"
						:lablewith="item.lablewith" :options="item.options" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :multiple="item.multiple" :types="item.types"
						@remoteMethod="remoteMethodtows($event,index)" @change="handChange" :inputtype="item.inputtype"
						:width="item.width">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<el-tooltip effect="dark" v-if="form.ExecuteDate" content="日期可不选，选择必须晚于档案的执行日期，截止日期必须晚于起始日期或执行日期"
						placement="bottom">
						<span class="tips">档案执行日期:{{form.ExecuteDate.substring(0,10)}}</span>
					</el-tooltip>
					<CommonBtngroup :show="false" :qhide="false" expt @select="select" @reset="reset" />
				</div>
				<div style="height:10px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";

	import {
		CustomerList,
	} from "@/api/home";

	import {
		GetIMSNTSList,
		GetProvinceCityTree,
		GetIMSNTSInvName,
		GetIMSNTSLevel3,
		GetIMSNTSInvAddCode,
		ExportIMSNTSData,
		GetHospitalList
	} from "@/api/newsapi";

	import utils from "../../../common/utils";

	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
		},
		data() {
			return {
				form: {},
				formdata: [{
						inputdata: "",
						title: "档案名",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectautocomplete",
						pt: true,
						width: "300px",
						btx: false,
						lablewith: "110px",
						options: [],
					},
					{
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectautocompletemultiple",
						pt: true,
						width: "300px",
						btx: false,
						lablewith: "110px",
						options: [],
					},
					{
						inputdata: "",
						title: "医院",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "hospitalMethod",
						inputtype: "selectautocompletemultiple",
						pt: true,
						width: "300px",
						btx: false,
						lablewith: "110px",
						options: [],
					},
					{
						inputdata: "",
						title: "省市",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "cascaderNodeParent",
						width: "312px",
						lablewith: "110px",
						multiple: true,
						height: '30px',
						btx: false,
					},
					{
						inputdata: "",
						title: "产品",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectMultiple",
						width: "300px",
						lablewith: "110px",
						btx: false,
					},
					{
						inputdata: "",
						title: "LEVEL3",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectMultiple",
						width: "300px",
						lablewith: "110px",
						btx: false,
					},
					{
						inputdata: "",
						title: "型号",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "selectMultiple",
						width: "300px",
						lablewith: "110px",
						btx: false,
					}, {
						inputdata: "",
						title: "日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "text",
						inputtype: "date",
						width: "180px",
						lablewith: "106px",
					}
				],
			};
		},
		mounted() {},
		methods: {
			//经销商下拉
			async remoteMethodtows(query, index) {
				if (index === 0) {
					let {
						data,
						code
					} = await GetIMSNTSList({
						INName: query
					});
					if (code == 0) {
						this.formdata[0].options = [];
						data.data.map((item, index) => {
							let obj = {
								key: item.INMID,
								value: item.INName,
								ExecuteDate: item.ExecuteDate,
							};
							this.formdata[0].options.push(obj);
						});
					}
				} else if (index === 1) {
					let {
						code,
						data
					} = await CustomerList({
						cusName: query,
						INMID: this.$refs.seselect[0].modelvalue ? this.$refs.seselect[0].modelvalue : ''
					});
					if (code == 0) {
						this.formdata[1].options = [];
						data.data.map((item, index) => {
							let obj = {
								key: item.CusCode,
								value: item.CusName,
							};
							this.formdata[1].options.push(obj);
						});
					}
				} else if (index === 2) {
					let {
						code,
						data
					} = await GetHospitalList({
						HPName: query,
						pageIndex: 1,
						pageSize: 9999,
						HosType: '医院',
						INMID: this.$refs.seselect[0].modelvalue ? this.$refs.seselect[0].modelvalue : ''
					})
					if (code == 0) {
						this.formdata[2].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.HPID,
								value: item.HPName,
							}
							this.formdata[2].options.push(obj)
						})
					}
				}
			},
			handChange(e) {
				if (Array.isArray(e)) {
					return;
				}
				let fdx = this.formdata[0].options.findIndex(it => it.key == e);
				this.form.ExecuteDate = fdx != -1 ? this.formdata[0].options[fdx].ExecuteDate : '';
				this.getProvinceCityTree();
				this.getHelperInvName();
				this.getHelperLevel3();
				this.getIMSNTSInvAddCode();
			},
			//省市
			async getProvinceCityTree() {
				let {
					code,
					data
				} = await GetProvinceCityTree({
					INMID: this.$refs.seselect[0].modelvalue ? this.$refs.seselect[0].modelvalue : ''
				});
				if (code == 0) {
					this.formdata[3].options = data;
					this.$forceUpdate();
				}
			},
			// 产品下拉
			async getHelperInvName() {
				let {
					code,
					data
				} = await GetIMSNTSInvName({
					INMID: this.$refs.seselect[0].modelvalue ? this.$refs.seselect[0].modelvalue : ''
				})
				if (code == 0) {
					this.formdata[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.InvName,
							value: item.InvName
						}
						this.formdata[4].options.push(obj);
					})
				}
			},
			//level3
			async getHelperLevel3() {
				let {
					data,
					code
				} = await GetIMSNTSLevel3({
					INMID: this.$refs.seselect[0].modelvalue ? this.$refs.seselect[0].modelvalue : ''
				})
				if (code == 0) {
					this.formdata[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.formdata[5].options.push(obj)
					})
				}
			},
			// 型号
			async getIMSNTSInvAddCode() {
				let {
					data,
					code
				} = await GetIMSNTSInvAddCode({
					INMID: this.$refs.seselect[0].modelvalue ? this.$refs.seselect[0].modelvalue : ''
				})
				if (code == 0) {
					this.formdata[6].options = []
					data.map((item, index) => {
						let obj = {
							key: item.InvAddCode,
							value: item.InvAddCode
						}
						this.formdata[6].options.push(obj)
					})
				}
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
					item.startTime = "";
					item.endTime = "";
				});
			},
			async select() {
				this.form.INMID = this.$refs.seselect[0].modelvalue;
				this.form.CustomerDetails = this.$refs.seselect[1].modelvalue;
				this.form.HospitalDetails = this.$refs.seselect[2].modelvalue;
				this.form.ProvinceCityDetails = this.$refs.seselect[3].modelvalue;
				this.form.InvNameDetails = this.$refs.seselect[4].modelvalue;
				this.form.LeveL3Details = this.$refs.seselect[5].modelvalue;
				this.form.InvAddCodeDetails = this.$refs.seselect[6].modelvalue;
				this.form.StartDate = this.$refs.seselect[7].startTime;
				this.form.EndDate = this.$refs.seselect[7].endTime;

				if (!this.form.INMID) {
					this.$message.warning("请选择档案名");
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportIMSNTSData(this.form);
				loading.close();
				if (resexprot) {
					utils.downloadFile(resexprot, "进销比报表", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 170px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 90px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;

		.tips {
			position: absolute;
			right: 180px;
			bottom: 30px;
			color: #e71d43;
			cursor: pointer;
		}
	}
</style>